import moment from "moment"
import Link from "next/link"
import Image from "next/image"
import { createObjectPagePathname, getMediaUrl, getAsServerMediaUrl } from "@/services/pathname"
import 'moment/locale/fr'
moment.locale('fr')
import { getName } from "@/services/aroeven"


type CardProps = {
    leisureActivity: LeisureActivity,
    filters?: any
}

export default function Card({
    leisureActivity,
    filters = null
}: CardProps) {

    return (
        <Link className={"vignette -type-1 h-100"} href={createObjectPagePathname('LeisureActivity', leisureActivity)}>
            <div className="vignette__image">
                <div className="cardImage">
                    <div className="cardImage__content">
                        {/*<img className="col-12" src={getMediaUrl(leisureActivity.medias.medias[0]?.media.url ?? process.env.NEXT_PUBLIC_HOLIDAYSTAY_DEFAULTIMAGE)} alt="image" loading="lazy" />*/}
                        <Image
                            className="col-12"
                            src={getAsServerMediaUrl(leisureActivity.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.url ?? '#')}
                            alt="image"
                            width={leisureActivity.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.metadata.width}
                            height={leisureActivity.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.metadata.height}
                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                            quality={50}
                        />
                    </div>
                    {/*<div className="cardImage__wishlist">
                        <div >à faire en famille</div>
                    </div>*/}
                    <div className="cardImage__leftBadge">
                        <div className="tag">
                            <h3 className="tag-title">{leisureActivity.minAge}{leisureActivity.minAge !== leisureActivity.maxAge && <>-{leisureActivity.maxAge}</>} ans</h3>
                            <div className="tag-tail" />
                        </div>
                    </div>
                </div>
                <div className="bandeau d-flex justify-content-between">
                    <div>
                        <i className="fi fi-rr-camping" />
                        Accueil de loisirs
                    </div>                    
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <div className="d-flex justify-content-between">
                            {leisureActivity.accomodations.length > 0 &&
                                <div className="flex-fill">
                                    <p className="text-light-1 lh-14 text-13 mt-5 mb-0">
                                        <i className="fi fi-rr-marker text-primary-4" /> {leisureActivity.accomodations.map((accomodation, indexAccomodation) => accomodation.address.city + ' (' + accomodation.address.postCode.slice(0, 2) + ')').filter((city, indexCity, cities) => cities.indexOf(city) === indexCity).join(', ')}
                                    </p>
                                </div>
                            }                            
                        </div>
                        <h4 className="vignette__title py-10">
                            {leisureActivity.name}
                        </h4>
                        {leisureActivity.type && <div className="type">{leisureActivity.type}</div>}                                                
                    </div>

                    <div className="d-flex flex-column justify-content-end">
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className='lh-1 mb-5'>
                                Organisé par {getName(leisureActivity.proposedBy)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}